import { useRouter }   from "next/router";
import { isPageRoute } from "_common/utils";
import Presentation    from "./presentation";

const DonationTabEmptyView = props => {
	const { feedItem, handleNotificationClick, activeUpdateTab, marked } = props;

	const router = useRouter ();

	const isNotificationsPage = isPageRoute ( { router, page: "notifications" } );

	return (
		<Presentation
			activeUpdateTab         = { activeUpdateTab }
			feedItem                = { feedItem }
			handleNotificationClick = { handleNotificationClick }
			isNotificationsPage     = { isNotificationsPage }
			marked                  = { marked }
		/>
	);
};

export default DonationTabEmptyView;